import React from 'react';
import {
  PhoneIcon,
  EnvelopeIcon,
  ArrowRightIcon
} from '@heroicons/react/24/outline';
import { useTranslation, Trans } from 'react-i18next';
import { trackEvent } from '../lib/metaPixel';

const CTA = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main CTA */}
        <div
          className="bg-gradient-to-r from-csl-green to-csl-dark-green rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-16 text-white text-center mb-12 sm:mb-16 relative overflow-hidden animate-slide-up"
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }} />
          </div>

          <div
            className="relative z-10 animate-fade-in [animation-delay:200ms]"
          >
            <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4 sm:mb-6">
              <Trans i18nKey="cta.title" components={{ 1: <span className="text-yellow-300" /> }} />
            </h2>

            <p className="text-base sm:text-lg md:text-xl opacity-90 mb-6 sm:mb-8 max-w-3xl mx-auto px-4">
              {t('cta.description')}
            </p>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
              <button
                onClick={() => {
                  trackEvent('Contact', { customData: { content_name: 'whatsapp-cta' } });
                  window.location.href = 'https://wa.me/237653459638';
                }}
                className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white text-csl-green font-semibold rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl group hover:scale-105 hover:-translate-y-0.5 active:scale-95 text-sm sm:text-base text-center"
              >
                <span className="text-center">{t('cta.button')}</span>
                <ArrowRightIcon className="ml-2 h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-1 transition-transform flex-shrink-0" />
              </button>
            </div>
          </div>
        </div>

        {/* Contact Options */}
        <div className="max-w-2xl mx-auto">
          {/* Email Contact */}
          <div
            className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 group animate-slide-in-up hover:-translate-y-1"
          >
            <div className="flex items-center mb-4 sm:mb-6">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-csl-green/10 rounded-xl flex items-center justify-center mr-3 sm:mr-4 group-hover:bg-csl-green/20 transition-colors duration-300">
                <EnvelopeIcon className="h-6 w-6 sm:h-8 sm:w-8 text-csl-green" />
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-csl-green transition-colors duration-300">
                  Email
                </h3>
                <p className="text-sm sm:text-base text-gray-600">contact@csl-brands.com</p>
              </div>
            </div>

            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">
              {t('cta.email.description')}
            </p>

            <a
              href="mailto:contact@csl-brands.com"
              className="w-full flex items-center justify-center px-4 sm:px-6 py-2.5 sm:py-3 border-2 border-csl-green text-csl-green font-semibold rounded-lg hover:bg-csl-green hover:text-white transition-all duration-300 group hover:scale-[1.02] active:scale-[0.98] text-sm sm:text-base"
            >
              {t('cta.email.button')}
              <EnvelopeIcon className="ml-2 h-4 w-4 group-hover:scale-110 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;